import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, Inject, OnInit, QueryList, Renderer2, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Produto, additionalProduct } from 'src/app/shared/Interfaces/produtos';
import { Item, additional, categoryAdd} from 'src/app/shared/Interfaces/pedido';
import { CartService } from 'src/app/shared/services/Cart/cart.service';
import { Company, ConnectionService } from 'src/app/shared/services/Connection/connection.service';
import { DOCUMENT } from '@angular/common';
import { ApiService } from 'src/app/shared/services/API/api.service';
import { ScrollService } from 'src/app/shared/services/Scroll/scroll.service';
import { typeInterface } from 'src/app/shared/Interfaces/company';
import { PixelService } from 'src/app/shared/services/pixel.service';
import { ItemObject } from 'src/app/shared/models/pedido.class';
import { NotificationService } from 'src/app/shared/services/notification.service';

@Component({
  selector: 'app-product-detail',
  templateUrl: './product-detail.component.html',
  styleUrls: ['./product-detail.component.css']
})

export class ProductDetailComponent implements OnInit, AfterViewInit
{

  //#region Variaveis de elementos HTML
    @ViewChildren('sectionsCategory') sectionsCategory!: QueryList<ElementRef>;
  //#endregion

  //#region Variaveis de Estilo
    alterationBg = false;
    showSideBar = true;
    toggleTopNavegation = true;
    alterationTopNavegation = false;
    showbutton = true;
    isZoom = false;
    desabilitButton = false;
    limitFlavors = false;
    limitEdges = false;
    isMobile: boolean = false;
    isDesktop: boolean = false;
    readOnlyState: boolean = false;
    collapseStates: boolean[] = [];
  //#endregion

  //#region Variaveis Locais

    //Variaveis Privadas
    typeParam!: typeInterface;
    private nameCompany: string = '';

    //Variaveis Booleanas
    requestSucess = false;
    permissionRequest = true;

    //Variaveis string
    textObservation: string = '';
    filter: string = '';

    //Variaveis Numericas
    scrollTopPosition: number = 0;
    statusCompany: number = 0;
    countText: number = 0;
    totalValue: number = 0;
    valorBase = 0;
    id!: number;
    counter: number = 1;

    //Variaveis de lista
    sectionPositions: number[] = [];
    additionalOrder: categoryAdd[] = [];

    //Variaveis de Objetos
    temporaryOrde!:Item;
    produto!: Produto;
    productOrder!: Produto;
    item!: ItemObject;
    company!: Company;
    baseFlavorsValue = 0;

    subCategoryEmpty: number[] = [];
    promotion: any;
    realPrice: any;

  //#endregion

  //#region Inicializadores

    constructor(
      private notify: NotificationService,
      private route: ActivatedRoute,
      private router: Router,
      private cartService: CartService,
      private changeDetectorRef: ChangeDetectorRef,
      private connection: ConnectionService,
      private scrollService: ScrollService,
      private apiService: ApiService,
      private renderer: Renderer2,
      private elementRef: ElementRef,
      private pixelService: PixelService,
      private cdr: ChangeDetectorRef,
      @Inject(DOCUMENT) private document: Document
      ){
        this.connection.nameCompany$.subscribe((newNameCompany) => {
          this.nameCompany = newNameCompany;
        })

        this.connection.statusCompany$.subscribe((newStatus) =>{
          this.statusCompany = newStatus;
        })

        this.connection.typeParam$.subscribe((newTypeParam) => {
          this.typeParam = newTypeParam;
        })

        this.connection.company$.subscribe((newCompany) =>{
          this.company = newCompany;
        })

        this.connection.permissionRequestOrder$.subscribe((newPermission) =>{
          this.permissionRequest = newPermission;
        })

        this.connection.readOnlyState$.subscribe((data) =>{
          this.readOnlyState = data;
        })
    }

    ngOnInit(){
      //Resgata o parametro id
      this.route.params.subscribe(params => {
        this.id = params['id_product'];
      })

      //Resgata as informações do produto
      this.getProduct();

      this.scrollService.scrollingSubject.next(true);

      //Altera o background
      this.alterationBG();

      //Desabilita o o refresh ao arrastar para baixo
      this.disablePullToRefresh();
    }

    ngAfterViewInit(){
      //Inclui ou remove a sidebar
      this.toggleSidebar();

      //Altera o menu de navegação superior
      this.toggleNavegationTop();

      //Calcula a posição das categorias de adicionais
      setTimeout(() => {
        this.calculateSectionPositions();
      }, 1000);

      this.alterationLayout();
    }

    ngOnDestroy() {}
  //#endregion

  //#region Funções de estilo (Style)

    //Inclui ou remove a sidebar da tela
    toggleSidebar(){
      if(window.innerWidth < 1169){
        this.showSideBar = false
        this.showbutton = false;
        this.changeDetectorRef.detectChanges();
      }
      else {
        this.showbutton = true;
        this.showSideBar = true;
        this.changeDetectorRef.detectChanges();
      }
    }

    //Altera o menu de navegação superior
    toggleNavegationTop(){
      if(window.innerWidth < 700)
      {
        this.toggleTopNavegation = false
        this.changeDetectorRef.detectChanges();
      }
      else if(window.innerWidth > 700)
      {
        this.toggleTopNavegation = true;
        this.changeDetectorRef.detectChanges();
      }
    }

    //Função responsavel por travar de o scroll para que a tela não seja recarregada no menu
    disablePullToRefresh() {
      const element = this.elementRef.nativeElement;
      let isAtTop = true;

      // Adiciona um ouvinte para o evento de scroll
      this.renderer.listen(window, 'scroll', () => {
        // Verifica se a página está no topo
        isAtTop = window.scrollY === 0;
      });

      this.renderer.listen(element, 'touchstart', (event) => {
        // Registra a posição inicial do toque
        const startY = event.touches[0].clientY;

        // Adiciona um ouvinte para o evento de movimento de toque
        const touchMoveListener = this.renderer.listen(element, 'touchmove', (moveEvent) => {
          // Calcula a diferença entre a posição inicial e a posição atual
          const deltaY = moveEvent.touches[0].clientY - startY;

          // Se a diferença for positiva (movimento para baixo) e a página estiver no topo, previne o comportamento padrão
          if (deltaY > 0 && isAtTop) {
            moveEvent.preventDefault();
          }
        });

        // Adiciona um ouvinte para o evento de término de toque
        const touchEndListener = this.renderer.listen(element, 'touchend', () => {
          // Remove os ouvintes após o término do toque
          touchMoveListener();
          touchEndListener();
        });
      });
    }

    //inclui a barra superior do menu de navegação
    includeDivBar(){
      this.scrollTopPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      if(window.innerWidth <= 846)
      {
        if(this.scrollTopPosition >= 380)
        {
          this.alterationTopNavegation = true
        }
        else{
          this.alterationTopNavegation = false
        }
      }
      else{}
    }

    //Abre a Imagem expandida
    zoomImageFirst(){
      this.isZoom = true;
    }

    //Fecha a imagem expandida
    notZoomImageLast(){
      this.isZoom = false;
    }

    //Altera o background
    alterationBG(){
      if(window.innerWidth <= 700)
      {
        this.alterationBg = false
      }
      else{
        this.alterationBg = true
      }
      this.changeDetectorRef.detectChanges();
    }

    //Altera o layout da aplicação
    alterationLayout(){
      this.scrollTopPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      //Mobile
      if(window.innerWidth <= 846)
      {
        this.isDesktop = false;
        this.isMobile = true;
      }
      //Desktop
      else
      {
        this.isMobile = false;
        this.isDesktop = true; 
      }

      this.cdr.detectChanges();
    }

    @HostListener('window:resize', [])
    onResize(){
      this.alterationBG();

      this.toggleSidebar();

      this.toggleNavegationTop();

      this.alterationLayout();

    }

    @HostListener('window:scroll', [])
    onScroll() {
      this.includeDivBar()
      this.alterationLayout();
    }

    //captura toda tecla clicado no text area e faz a contagem
    capturaTexArea(event: Event){
      const inputElement = event?.target as HTMLInputElement;

      if (inputElement.value.length <= 48) {
        this.textObservation = inputElement.value;
        this.countText = this.textObservation.length;
      } else {
        inputElement.value = this.textObservation;
      }
    }

    //Calcula as posições das categorias dos adicionais
    calculateSectionPositions() {
      this.sectionPositions = []
      this.sectionsCategory.forEach(section => {
        if (section && section.nativeElement) {

          this.sectionPositions.push(section.nativeElement.offsetTop);
        }
      });
    }

    //Abre e fecha as categorias dos adicionais
    toggleCollapse(index: number):void{
      this.collapseStates[index] = !this.collapseStates[index];
    }

    //Função de compartilhar o link do cardápio
    share(): void {
      if (navigator.share) {
        navigator.share({
          title: `Veja este produto disponível no cardápio de ${this.company.company.companyName}`,
          url: `https://pedeaqui.app/${this.nameCompany}/product-detail/${this.id}`
        }).then(() => {
          console.log('Compartilhado com sucesso!');
        })
        .catch(console.error);
      } 
    }

    //#region Valid Selection

      //Checa a categoria e bloqueia se atingir numero maximo
      checkCategory(categorieSelected: any, i: number){
        const element = document.querySelectorAll('.box-collapse')

        const category = this.additionalOrder.find(
          category => categorieSelected.id_category === category.id_category
        )

        let counter = 0
        if(category){
          category.additional.forEach(element =>{
            counter += element.quantitySub
          })
        }

        if(category){
          if(category?.division != 0)
          {
            if(counter == categorieSelected.division)
            {
              element[i].classList.add('disabled')

            }
            else{
              element[i].classList.remove('disabled');
            }
          }
        }
        else{
          element[i].classList.remove('disabled');
        }
      }

      //Verifica se todas as categorias requeridas estão selecionadas para poder avançar
      confimationCategories(){
        if(this.produto.categories){
          const categoriasRequired = this.produto.categories.filter(category => category.required === 1)
          const categoriasRequiredOrder = this.additionalOrder.filter(category => category.required === 1)

          if(categoriasRequired.length != categoriasRequiredOrder.length){
            this.desabilitButton = true;
            if(this.produto.pizza == 1)
            {
              let counterFlavors = 0;
              let counterEdge = 0;
              this.additionalOrder.forEach(categoria => {
                categoria.additional.forEach(adicional =>{
                  if(categoria.flavorCategory == 1)
                  {
                    counterFlavors = counterFlavors + adicional.quantitySub
                  }
                  else if(categoria.edgeCategory == 1){

                    counterEdge = counterEdge + adicional.quantitySub
                  }
                })
              })
    
              if(counterFlavors < this.produto.maxDivision)
              {
                this.limitFlavors = false
              }
              else if(counterFlavors == this.produto.maxDivision)
              {
                this.limitFlavors = true;
              }

              if(this.produto.edgeDivision != 0){

                if(counterEdge < this.produto.edgeDivision)
                {
                  this.limitEdges = false
                }
                else if(counterEdge == this.produto.edgeDivision)
                {
                  this.limitEdges = true;
                }
              }
            }
          }
          else{
            if(this.produto.pizza == 1)
            {
              let counterFlavors = 0;
              let counterEdge = 0;

              this.additionalOrder.forEach(categoria => {
                categoria.additional.forEach(adicional =>{
                  if(categoria.flavorCategory == 1)
                  {
                    counterFlavors = counterFlavors + adicional.quantitySub
                  }
                  else if(categoria.edgeCategory == 1)
                  {
                    counterEdge = counterEdge + adicional.quantitySub
                  }
                })
              })
    
              if(counterFlavors < this.produto.maxDivision)
              {
                this.limitFlavors = false
                if(counterFlavors < 1)
                {
                  this.desabilitButton = true;
                }
                else{
                  this.desabilitButton = false;
                }
              }
              else if(counterFlavors == this.produto.maxDivision)
              {
                this.desabilitButton = false;
                this.limitFlavors = true;
    
              }


              if(this.produto.edgeDivision != 0){

                if(counterEdge < this.produto.edgeDivision)
                {
                  this.limitEdges = false;
                }
                else if(counterEdge == this.produto.edgeDivision)
                {
                  this.limitEdges = true;
                }
              }
            }
            else{
              this.desabilitButton = false;
              categoriasRequired.forEach(cat => {
                const catOrder = categoriasRequiredOrder.find(categorie => categorie.id_category == cat.id_category);

                if(catOrder){
                  let count = 0;
                  catOrder.additional.forEach(additional => {
                    count += additional.quantitySub
                  });
                  if(count < catOrder.minDivision){
                    this.desabilitButton = true;
                    return;
                  }
                }
              });
              
            }


          }
        }
      }

      //Da o scroll até a categoria de adicionais
      scrollToCategory(categorieSelected: any, i: number){
        this.calculateSectionPositions()
        const category = this.additionalOrder.find(
          category => categorieSelected.id_category === category.id_category
        )

        let categoryLength = 0;

        category?.additional.forEach(additional =>{
          categoryLength += additional.quantitySub
        })
        if(category?.division == categoryLength){
          if(this.limitFlavors)
          {
            for (let index = 0; index < this.produto.categories.length; index++) {
              const category = this.produto.categories[index];
              if(index >= i){
                if (category.flavorCategory == 0) {
                  window.scrollTo({ top: this.sectionPositions[index], behavior: 'smooth' });

                  break;
                }
                else{
                  if(index == this.produto.categories.length - 1)
                  {
                    window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
                  }
                }
              }
            }
          }
          else{
            window.scrollTo({top: this.sectionPositions[Number(i + 1)], behavior: 'smooth'});
          }
        }
        else{
          if(category?.flavorCategory != 0){
            if(this.limitFlavors)
            {
              
              for (let index = 0; index < this.produto.categories.length; index++) {
                const category = this.produto.categories[index];
                if(index >= i){
                  if (category.flavorCategory == 0) {
                    window.scrollTo({ top: this.sectionPositions[index], behavior: 'smooth' });
                    break;
                  }
                  else{
                    if(index == this.produto.categories.length - 1)
                    {
                      window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
                    }
                  }
                }
              }
            }
          }

        }
      }

      //desabilita o botão de adicionar de acordo com as condições
      desabilitButtons(){
        if(this.produto.categories){
          if(this.produto.categories.length == 0)
          {
            this.desabilitButton = false;
          }
          else{

            const categoriasRequired = this.produto.categories.filter(category => category.required === 1)

            if(categoriasRequired)
            {
              if(categoriasRequired.length != 0){
                this.desabilitButton = true;
              }
              else{
                if(this.produto.pizza == 1)
                {
                  this.desabilitButton = true;
                }

              }
            }

          }

        }
        else{
          this.desabilitButton = false;
        }
      }

    //#endregion

  //#endregion

  //#region Funções de lógica (Logic)

    //Puxa todas as caracteristicas do produto selecionado
    getProduct(){
        this.apiService.getProduto(this.id, this.typeParam.type).subscribe((data) =>{

          //Variavel produto recebe o valor do request
          this.produto = data.Product;

          setTimeout(() => {
            if(this.produto.active == 0){
              this.notify.error('Este produto não está mais disponível no cardápio.')
              this.goback()
            }
          }, 2100);


          // Inicializa as variáveis de promoção
          this.promotion = this.produto.promotion || 0;
          this.realPrice = this.produto.realPrice || this.produto.price;


          //Percorre o produto e adiciona zero a todos adicionais
          if(this.produto.categories)
          {
            this.produto.categories.forEach(category => {
              category.products.forEach(produto =>{
                produto.quantity = 0;
              })
            });
          }

          //Carrega as variaveis com o preço do produto
          this.totalValue = Number(this.produto.price)
          this.valorBase = Number(this.produto.price)


          //Extrai as categorias de produto e deixa as categorias de productOrder vazias
          const { categories, ...productWithoutCategories } = this.produto;

          this.productOrder = {
            ...productWithoutCategories,
            categories: [],
          };

          setTimeout(() => {
            this.requestSucess = true
            window.scrollTo({
              behavior: 'instant' as ScrollBehavior,
              top: 0,
              left: 0
            })
          }, 300);

          //Verifica as condições para desabilitar o botão de adicionar
          this.desabilitButtons();
        },
        (error) =>{
          this.requestSucess = false;
        }
        )

    }

    //retorna a pagina anterior
    goback(): void{
      this.cartService.productEditionSubject.next(this.temporaryOrde)
      if(this.typeParam.type == 1 || this.typeParam.type == 2)
      {
        this.router.navigate([this.nameCompany, 'P']);
      }
      else if(this.typeParam.type == 3)
      {
        this.router.navigate([this.nameCompany, 'B']);
      }
      else{
        this.router.navigate([this.nameCompany]);
      }
    }

    //#region Lógica quantidade do item geral

      //Remove 1 na multiplição do item
      removeOneInCounter(){
        this.counter = this.counter - 1;

        if(this.produto.pizza == 1)
        {
          this.totalValue = this.totalValue * this.counter

          //Divisão
          if(this.company.company.pizzaDivision  == 0)
          {
            this.logicDivision();
          }
          //Maior Valor
          else if(this.company.company.pizzaDivision  == 1)
          {
            this.logicMaxValue();
          }
          //Média Ponderada
          else if(this.company.company.pizzaDivision  == 2 || this.company.company.pizzaDivision == 3)
          {
            this.logicDivisionCeil();
          }
          //Lógica Steve
          else if(this.company.company.pizzaDivision == 4) {
            this.logicSteve();
          }

        }
        else{
          this.totalValue = this.valorBase * this.counter
        }

      }

      //Multiplica o valor total do item
      addOneInCounter(){
        this.counter = this.counter + 1;

        if(this.produto.pizza == 1)
        {
          this.totalValue = this.totalValue * this.counter;

          //Divisão
          if(this.company.company.pizzaDivision  == 0)
          {
            this.logicDivision();
          }
          //Maior Valor
          else if(this.company.company.pizzaDivision  == 1)
          {
            this.logicMaxValue();
          }
          //Média Ponderada
          else if(this.company.company.pizzaDivision  == 2 || this.company.company.pizzaDivision == 3)
          {
            this.logicDivisionCeil();
          }
          //Lógica Steve
          else if(this.company.company.pizzaDivision == 4) {
            this.logicSteve();
          }
        }
        else{
          this.totalValue = this.valorBase * this.counter;
        }

      }

    //#endregion

    //#region Lógica para adicionar e remover adicionais

      /**
       * Adiciona e remove o adicional no objeto caso a maxima escolha da categoria seja 1.
       * 
       * @param {additionalProduct} adicional - Adicional selecionado.
       * @param {any} category - Categoria selecionada.
       * @param {any} i - Posição da categoria selecionada.
      */
      changeAdd(adicional: additionalProduct, category: any, i: number) {

        //Encontra a categoria selecionada
        const foundCat = this.additionalOrder.find(cat => cat.id_category === category.id_category);
        
        if (foundCat) {
          //Encontra o produto selecionado na categoria selecinada
          const foundProd = foundCat.additional.find(product => product.add_id_product === adicional.id_product);
          
          if (foundProd) {
            //Remove o produto caso ele já exista
            return this.removeOneInCounterAdd(adicional, category, i);
          }
      
          this.handleCategoryReplacement(foundCat, adicional, category, i);

        } else {
          if(category.flavorCategory == 1){
            if (this.produto.pizza === 1 && this.produto.maxDivision === 1) {
              //Encontra qualquer categoria de sabor no objeto
              const foundFlavorCat = this.additionalOrder.find(cat => cat.flavorCategory === 1);
              
              if (foundFlavorCat) {
                return this.handleCategoryReplacement(foundFlavorCat, adicional, category, i);
              }
            }
            this.addOneInCounterAdd(adicional, category, i);
          }
          else{
            this.addOneInCounterAdd(adicional, category, i);
          }
          
        }
      }
      
      /**
       * Substitui adicionais dentro da Categorias.
       * 
       * @param {any} foundCat - Categoria encontrada anteriormente.
       * @param {additionalProduct} adicional - Adicional selecionado.
       * @param {any} categorieSelected - Categoria selecionada.
       * @param {any} i - Posição da categoria selecionada.
      */
      handleCategoryReplacement(foundCat: any, adicional: additionalProduct, category: any, i: number) {
        const foundCat2 = this.produto.categories.find(cat => cat.id_category === foundCat.id_category);
        
        if (foundCat2) {
          const foundProduct = foundCat2.products.find(product => product.id_product === foundCat.additional[0]?.add_id_product);
          
          if (foundProduct) {
            this.removeOneInCounterAdd(foundProduct, foundCat2, i);
          }
        }
        
        this.addOneInCounterAdd(adicional, category, i);
      }

      /**
       * Remove o adicional do objeto ou a quantidade dele.
       * 
       * @param {additionalProduct} adicional - Adicional selecionado.
       * @param {any} categorieSelected - Categoria selecionada.
       * @param {any} i - Posição da categoria selecionada.
      */
      removeOneInCounterAdd(adicional: additionalProduct, categorieSelected: any, i: number){
        if (adicional.quantity > 0) {
          adicional.quantity--;
        }

        const indexCategoria = this.additionalOrder.findIndex(item => item.id_category === categorieSelected.id_category);

        if (indexCategoria !== -1) {
          const categoria = this.additionalOrder[indexCategoria];

          const indexAdicional = categoria.additional.findIndex(item => item.add_id_product == adicional.id_product);

          if (indexAdicional !== -1) {

            const additional = this.additionalOrder[indexCategoria].additional[indexAdicional];

            if(additional.quantitySub > 1)
            {
              this.additionalOrder[indexCategoria].additional[indexAdicional].quantitySub -= 1
              this.additionalOrder[indexCategoria].additional[indexAdicional].totalPriceSub -= this.additionalOrder[indexCategoria].additional[indexAdicional].unitPriceSub
            }
            else{
              this.additionalOrder[indexCategoria].additional.splice(indexAdicional, 1);
            }

          }

          if(categoria.additional.length == 0)
          {
            this.additionalOrder.splice(indexCategoria, 1)
          }

          if(this.produto.pizza == 1)
          {
            if(this.additionalOrder.length != 0)
            {
              //Média
              if(this.company.company.pizzaDivision == 0)
              {
                this.logicDivision();
              }
              //Maior
              else if(this.company.company.pizzaDivision  == 1)
              {
                this.logicMaxValue();
              }
              //Média Ponderada
              else if(this.company.company.pizzaDivision  == 2 || this.company.company.pizzaDivision == 3)
              {
                this.logicDivisionCeil();
              }
              //Lógica Steve
              else {
                this.logicSteve();
              }
            }
            else{
              this.totalValue = 0;
            }
          }
          else{
            this.logicTotalItem()
          }

          this.confimationCategories();

        }

        if(categorieSelected.division > 1){
          this.checkCategory(categorieSelected, i)
        }

      }

      /**
       * Adiciona o adicional no objeto ou a quantidade dele.
       * 
       * @param {additionalProduct} adicional - Adicional selecionado.
       * @param {any} categorieSelected - Categoria selecionada.
       * @param {any} i - Posição da categoria selecionada.
      */
      addOneInCounterAdd(adicional: additionalProduct, categorieSelected: any, i: number){

        adicional.quantity++

        const item: additional = {
          add_id_product : adicional.id_product,
          nameSub: adicional.name,
          quantitySub: adicional.quantity,
          unitPriceSub: adicional.price,
          totalPriceSub: adicional.price * adicional.quantity,
          paymentAccept: adicional.paymentAccept,
          observationsSub: ''
        }

        const existingCategory = this.additionalOrder.find(category => categorieSelected.id_category === category.id_category)

        if(existingCategory){

          const existingItem = existingCategory.additional.find(subItem => item.add_id_product === subItem.add_id_product)

          if(existingItem)
          {
            existingItem.quantitySub = item.quantitySub
            existingItem.totalPriceSub = item.totalPriceSub
            existingItem.observationsSub = item.observationsSub
          }
          else{
            existingCategory.additional.push(item)
          }
        }
        else{

          const category: categoryAdd = {
            id_category: categorieSelected.id_category,
            categoryName: categorieSelected.categoryName,
            additional: [],
            minDivision: categorieSelected.minDivision,
            division: categorieSelected.division,
            flavorCategory: categorieSelected.flavorCategory,
            edgeCategory: categorieSelected.edgeCategory,
            required: categorieSelected.required,
            categoryLength: categorieSelected.categoryLength,
            sumType: categorieSelected.sumType,
            quantitySelected: 0,
            valueSelected: 0
          }
          
          category.additional.push(item)
          this.additionalOrder.push(category)
        }

        if(this.produto.pizza == 1)
        {
          //Média
          if(this.company.company.pizzaDivision == 0)
          {
            this.logicDivision();
          }
          //Maior Valor
          else if(this.company.company.pizzaDivision  == 1)
          {
            this.logicMaxValue();
          }
          //Média Ponderada
          else if(this.company.company.pizzaDivision == 2 || this.company.company.pizzaDivision == 3)
          {
            this.logicDivisionCeil();
          }
          //Lógica Steve
          else if(this.company.company.pizzaDivision == 4) {
            this.logicSteve();
          }

        }
        else{
          this.logicTotalItem()
        }

        this.confimationCategories();
        this.scrollToCategory(categorieSelected, i)

        if(categorieSelected.division > 1){
          this.checkCategory(categorieSelected, i)
        }
        
        this.changeDetectorRef.detectChanges()
      }

    //#endregion

    //#region Lógicas para calcular Sabores, Bordas e Adicionais

      //Calcula o total do item
      logicTotalItem(){
        this.valorBase = 0;
        this.totalValue = 0;
        this.totalValue = 0

        const valueGroups = this.logicGroups();

        this.totalValue = Number(this.produto.price) + valueGroups

        this.valorBase = this.totalValue;

        this.totalValue = this.totalValue * this.counter
      }

      //Lógica que calcula e retorna o valor dos adicionais | 0 - Soma | 1 - Divisão | 2 - Valor Maior | 3 - Média ponderada / 1 | 4 - Média ponderada / 2
      logicGroups(): number{
        let provisionalValue = 0

        this.additionalOrder.forEach(categoria => {

          if(categoria.flavorCategory == 0 && categoria.edgeCategory == 0){
            categoria.quantitySelected = 0;
            categoria.valueSelected = 0;
            

            categoria.additional.forEach(adicional =>{

              if(categoria.sumType == 0 || categoria.sumType == 1 || categoria.sumType == 3 || categoria.sumType == 4){
                categoria.quantitySelected += adicional.quantitySub
                categoria.valueSelected += adicional.totalPriceSub
              }
              else if(categoria.sumType == 2){
                if(adicional.quantitySub > 1){

                  const value = adicional.totalPriceSub / adicional.quantitySub;

                  if(value > categoria.valueSelected){

                    categoria.valueSelected = value;

                  }
                }
                else{
                  if(adicional.totalPriceSub > categoria.valueSelected)
                  {
                    categoria.valueSelected = adicional.totalPriceSub
                  }
                }
              }
            })
          }

        });

        this.additionalOrder.forEach(categoria => {

          if(categoria.flavorCategory == 0 && categoria.edgeCategory == 0){

            if(categoria.sumType == 0 || categoria.sumType == 2){
              provisionalValue += categoria.valueSelected
            }
            else if(categoria.sumType == 1 || categoria.sumType == 3 || categoria.sumType == 4){
              const valueDivison = categoria.valueSelected / categoria.quantitySelected

              let valueFormatted = 0;

              if(categoria.sumType == 1)
              {
                valueFormatted = valueDivison; //Apenas a valor da divisão
              }
              if(categoria.sumType == 3)
              {
                valueFormatted = Math.ceil(valueDivison * 10) / 10; //Arredonda para cima em intervalos de 0.1
              }
              else if(categoria.sumType == 4)
              {
                valueFormatted = Math.ceil(valueDivison * 2) / 2; //Arredonda para cima em intervalos de 0.5
              }

              provisionalValue += valueFormatted;
            }

          }

        });

        return provisionalValue;
      }

      //Lógica para calcular a divisão do valor do sabor | 0 - Média
      logicDivision(){
        let quantyFlavor = 0;
        let valueFlavor = 0;

        let quantyEdge = 0;
        let valueEdge = 0;

        //Valores provisorios
        let provisionalValuePizza = 0;
        let provisionalValueEdge = 0;
        let provisionalValueProduct = 0;

        //Percorre todo o array temporario de adicionais
        this.additionalOrder.forEach(categoria => {
          categoria.additional.forEach(adicional =>{
            //Verifica se a categoria que o for esta passando é um sabor
            if(categoria.flavorCategory == 1)
            {
              quantyFlavor += adicional.quantitySub;
              valueFlavor += adicional.totalPriceSub
            }
            else if(categoria.edgeCategory == 1)
            {
              quantyEdge += adicional.quantitySub;
              valueEdge += adicional.totalPriceSub
            }
          })

        })

        //Se o value o quantidadeTotal forem diferentes de 0 ele atribui essa divisão ao valor provisorio
        if(valueFlavor && quantyFlavor)
        {
          provisionalValuePizza = valueFlavor / quantyFlavor;
        }
        if(valueEdge && quantyEdge)
        {
          provisionalValueEdge = valueEdge / quantyEdge;
        }

        provisionalValueProduct = this.logicGroups();

        this.totalValue = Number(provisionalValuePizza + provisionalValueEdge + provisionalValueProduct)

        this.valorBase = this.totalValue

        //Verifica se a variavel counter esta maior que zero para multiblicar o valor total pelo numero da varivel
        if(this.counter != 1){
          this.totalValue = this.totalValue * this.counter
        }
      }

      //Lógica para calcular a divisão do valor do sabor Média Ponderada | 2 ou 3 - Média Ponderada
      logicDivisionCeil(){
        let quantyFlavor = 0;
        let valueFlavor = 0;

        let quantyEdge = 0;
        let valueEdge = 0;

        //Valores provisorios
        let provisionalValuePizza = 0;
        let provisionalValueEdge = 0;
        let provisionalValueProduct = 0;

        let valueTotalCategoriesType = 0

        //Percorre todo o array temporario de adicionais
        this.additionalOrder.forEach(categoria => {
          categoria.additional.forEach(adicional =>{
            //Verifica se a categoria que o for esta passando é um sabor
            if(categoria.flavorCategory == 1)
            {
              quantyFlavor += adicional.quantitySub;
              valueFlavor += adicional.totalPriceSub
            }
            else if(categoria.edgeCategory == 1)
            {
              quantyEdge += adicional.quantitySub;
              valueEdge += adicional.totalPriceSub;
            }
          })

        })

        //Se o value o quantidadeTotal forem diferentes de 0 ele atribui essa divisão ao valor provisorio
        if(valueFlavor && quantyFlavor)
        {
          provisionalValuePizza = valueFlavor / quantyFlavor;

          if(this.company.company.pizzaDivision == 2)
          {
            provisionalValuePizza = Math.ceil(provisionalValuePizza * 10) / 10; //Arredonda para cima em intervalos de 0.1
          }
          else
          {
            provisionalValuePizza = Math.ceil(provisionalValuePizza * 2) / 2; //Arredonda para cima em intervalos de 0.5
          }
        }

        if(valueEdge && quantyEdge)
        {
          provisionalValueEdge = valueEdge / quantyEdge;

          provisionalValueEdge = Number(provisionalValueEdge.toFixed(2));

          provisionalValueEdge = Math.floor(provisionalValueEdge * 10) / 10;
        }

        provisionalValueProduct = this.logicGroups();

        this.totalValue = Number(provisionalValuePizza + provisionalValueEdge + provisionalValueProduct + valueTotalCategoriesType)

        this.valorBase = this.totalValue

        //Verifica se a variavel counter esta maior que zero para multiblicar o valor total pelo numero da varivel
        if(this.counter != 1){
          this.totalValue = this.totalValue * this.counter
        }

      }

      //Lógica para calcular o maior valor do sabor Valor maior | 1 - Maior Valor
      logicMaxValue(){

        //Valores provisorios
        let provisionalValuePizza = 0;
        let provisionalValueEdge = 0;
        let provisionalValueProduct = 0;

        let valueTotalCategoriesType = 0

        //Percorre o Array de adicionais tempoararios
        this.additionalOrder.forEach(categoria => {

            categoria.additional.forEach(adicional =>{
              //Sabores
              if(categoria.flavorCategory == 1){
                //Calcula o valor do adicional dividido pela quantidade e se esse valor for maior do que esta registrado no valor provisorio, ele substitui
                if(adicional.quantitySub > 1)
                {
                  const value = adicional.totalPriceSub / adicional.quantitySub

                  if(value > provisionalValuePizza)
                  {
                    provisionalValuePizza = value
                  }
                }
                else{
                  if(adicional.totalPriceSub > provisionalValuePizza)
                  {
                    provisionalValuePizza = adicional.totalPriceSub
                  }
                }

              }
              //Bordas
              else if(categoria.edgeCategory == 1){
                //Calcula o valor do adicional dividido pela quantidade e se esse valor for maior do que esta registrado no valor provisorio, ele substitui
                if(adicional.quantitySub > 1){

                  const value = adicional.totalPriceSub / adicional.quantitySub;

                  if(value > provisionalValueEdge){

                    provisionalValueEdge = value;

                  }
                }
                else{
                  if(adicional.totalPriceSub > provisionalValueEdge)
                  {
                    provisionalValueEdge = adicional.totalPriceSub
                  }
                }
              }
            })
        })

        provisionalValueProduct = this.logicGroups();

        //Total value recebe o valor das variaveis acima
        this.totalValue = Number(provisionalValuePizza + provisionalValueEdge + provisionalValueProduct + valueTotalCategoriesType)

        this.valorBase = this.totalValue

        if(this.counter != 1){
          this.totalValue = this.totalValue * this.counter
        }
      }

      //Lógica para calcular o valor do sabor (especifico)
      logicSteve(){
        let provisionalValuePizza = 0;
        let provisionalValueEdge = 0;
        let provisionalValueProduct = 0;

        let qtdeMaior = 0;
        let qtdeMenor = 0;
        let maiorValor = 0;
        let menorValor = 0;

        this.additionalOrder.forEach(category => {
          category.additional.forEach(adicional => {
            if(category.flavorCategory == 0 && category.edgeCategory == 0)
            {
              provisionalValueProduct += adicional.totalPriceSub
            }
            if(category.flavorCategory == 1){
              if(qtdeMaior == 0){
                qtdeMaior = adicional.quantitySub;
                maiorValor = Number(adicional.unitPriceSub)
              }
              else{
                if(Number(adicional.unitPriceSub) > maiorValor)
                {
                  qtdeMenor = qtdeMaior;
                  qtdeMaior = adicional.quantitySub;
                  menorValor = maiorValor;
  
                  maiorValor = Number(adicional.unitPriceSub);
                }
                else if(Number(adicional.unitPriceSub) == maiorValor)
                {
                  qtdeMaior++;
                }
                else if(Number(adicional.unitPriceSub) == menorValor)
                {
                  qtdeMenor++;
                }
                else if(menorValor == 0)
                {
                  qtdeMenor = adicional.quantitySub;
                  menorValor = Number(adicional.unitPriceSub);
                }
                
              }
            }
            else if(category.edgeCategory == 1){
              if(adicional.quantitySub > 1){

                const value = adicional.totalPriceSub / adicional.quantitySub;

                if(value > provisionalValueEdge){

                  provisionalValueEdge = value;

                }
              }
              else{
                if(adicional.totalPriceSub > provisionalValueEdge)
                {
                  provisionalValueEdge = adicional.totalPriceSub
                }
              }
            }

          });

        });

        if (this.produto.maxDivision == 2 && qtdeMaior == 1 && qtdeMenor == 1)
        {
          provisionalValuePizza = Number(menorValor) + 20;
        }
        else if (qtdeMaior >= qtdeMenor)
        {
          
          // if((qtdeMaior == 2 && qtdeMenor == 2) || (qtdeMaior == 2 && qtdeMenor == 1) && this.produto.maxDivision == 4)
          // {
          //   provisionalValuePizza = Number(maiorValor) - 15;
          // }
          // else{
          //   provisionalValuePizza = maiorValor;
          // }

          provisionalValuePizza = maiorValor;

        }
        else if (qtdeMaior < qtdeMenor)
        {
            if(qtdeMaior + qtdeMenor == 3 && this.produto.maxDivision == 4)
            {
              provisionalValuePizza = Number(menorValor) + 23;
            }
            else
            {
              provisionalValuePizza = Number(menorValor) + 20;
            }
        }

        this.totalValue = Number(provisionalValuePizza + provisionalValueEdge + provisionalValueProduct)

        this.valorBase = this.totalValue

        if(this.counter != 1){
          this.totalValue = this.totalValue * this.counter
        }
      }

    //#endregion

    //#region Montar o item e passar para o carrinho

      //Formata o objeto com as informações de pizza.
      FormatationItem(){
        this.totalValue
        let quantityFlavor = 0;
        let quantityEdge = 0;
        let valueFlavor = 0;
        let valueEdge = 0;
        let pizzaPrice = 0
        let flavorsValue = 0;
        let additionalsValue = 0;


        let flavors = { 
          totalValue: 0,
          divisionValue: 0
        }

        let edges = {
          totalValue: 0,
          divisionValue: 0
        }

        if(this.productOrder.pizza == 1){

          //#region Divide os valores dos sabores e bordas

            //Percorre a lista, Verifica se uma categoria é sabor e resgata o valor e as quantidades para Sabor e Borda
            this.additionalOrder.forEach(categoria => {
              if(categoria.flavorCategory == 1)
              {
                categoria.additional.forEach(adicional =>{
                  quantityFlavor += adicional.quantitySub;
                  valueFlavor += adicional.totalPriceSub
                })
                categoria.categoryLength = quantityFlavor
              }
              else if(categoria.edgeCategory == 1)
              {
                categoria.additional.forEach(adicional =>{
                  quantityEdge += adicional.quantitySub;
                  valueEdge += adicional.totalPriceSub
                })
                categoria.categoryLength = quantityEdge
              }
              
            })

            //Faz a divisão e valores dos sabores
            flavors.totalValue = valueFlavor / quantityFlavor
            flavors.divisionValue = flavors.totalValue / quantityFlavor

            //Faz a divisão e valores das bordas
            edges.totalValue = valueEdge / quantityEdge
            edges.divisionValue = edges.totalValue / quantityEdge

            //Percorre a lista novamente e adiciona ao valores dos adicionais o valor dividido para Sabor e Borda
            this.additionalOrder.forEach(categoria => {
              if(categoria.flavorCategory == 1)
              {
                categoria.additional.forEach(adicional =>{
                  if(this.company.company.pizzaDivision  == 2)
                  {
                    adicional.totalPriceSub  = Number(flavors.divisionValue)
                  }
                  else if(this.company.company.pizzaDivision  == 4)
                  {
                    let result;
                    const teste = adicional.unitPriceSub / quantityFlavor;
                    const percent = Number((teste / flavors.totalValue) * 100).toFixed(2);

                    if(this.counter > 1){
                      const totalValue = this.totalValue / this.counter;
                      result = (totalValue * Number(percent)) / 100
                    }
                    else{
                      result = (this.totalValue * Number(percent)) / 100
                    }

                    adicional.totalPriceSub = Number(result.toFixed(2));
                  }
                  else{
                    adicional.totalPriceSub  = Number(flavors.divisionValue.toFixed(2))
                  }
                  
                })
              }
              else if(categoria.edgeCategory == 1){
                categoria.additional.forEach(adicional =>{
                  if(this.company.company.pizzaDivision  == 2)
                  {
                    adicional.totalPriceSub  = Number(edges.divisionValue)
                  }
                  else{
                    adicional.totalPriceSub  = Number(edges.divisionValue.toFixed(2))
                  }

                })
              }

            })

          //#endregion


          //Soma apenas os valores dos adicionais incluindo bordas
          this.additionalOrder.forEach(categoria => {

            if(categoria.flavorCategory == 0)
            {
              categoria.additional.forEach(additional =>{
                additionalsValue += additional.totalPriceSub
              })
            }
          })

          //Resgata os valores dos adicionais e multiplica por counter, e formata para média ponderada caso a configuração
          if(this.company.company.pizzaDivision  == 2){
            additionalsValue = Math.floor(additionalsValue * 10) / 10;
            additionalsValue = additionalsValue * this.counter
          }
          else{
            additionalsValue = additionalsValue * this.counter
          }

          //Resgata a o valo base de sabores no produto, idependete do counter
          if(additionalsValue != 0)
          {
            this.baseFlavorsValue = this.totalValue - additionalsValue;
            this.baseFlavorsValue = this.baseFlavorsValue / this.counter
            flavorsValue = this.totalValue - additionalsValue;
          }
          else{
            this.baseFlavorsValue = this.totalValue / this.counter
            flavorsValue = this.totalValue;
          }

          //Resgata os valores apenas de sabores descontando bordas e adicionais
          if(flavorsValue){
            if(this.company.company.pizzaDivision  == 2)
            {
              pizzaPrice = Math.ceil(flavorsValue)
            }
            else{
              pizzaPrice = flavorsValue
            }
          }

        }

        //Inicializa o objeto do Item
        this.item = new ItemObject(
          this.productOrder, //Produto
          this.counter, //Contador
          this.textObservation, //Observação
          this.additionalOrder, //Adicionais
          this.valorBase, //Valor base do item
          this.totalValue, //Valor total do item
          pizzaPrice, //Valor da pizza
          flavorsValue, //Valor de sabores
          this.baseFlavorsValue, //Valor base de sabores
          this.promotion, //Promoção
          this.realPrice, //Valor real do item
          Number(this.productOrder.cashback), // Cashback
          this.productOrder.cashbackType, // Cashback Type
          this.productOrder.deliveryOn //Delivery On
        )
      }

      //Adiciona o Item e suas caracteristicas ao seu carrinho
      addProduct(){
        //Formata o objeto
        this.FormatationItem();

        //Adiciona o Item ao carrinho
        this.cartService.addToCart(this.item)

        //Emite o evento de Item adicionado ao carrinho para o Pixel(Facebook)
        this.pixelService.sendEventAddToCart(this.item);

        //Mensagem de Sucesso
        this.notify.success(`${this.produto.name} foi adicionado ao carrinho com sucesso!`)

        this.cartService.productEditionSubject.next(this.temporaryOrde)
      }

      //Se o usuario escolher continuar comprando ele removera a possibilidade de não fazer scroll, e adicionara o produto no carrinho
      finishedItem(){

        let confirmOrder: boolean = true;
        let activeOnline: boolean = true;
        if(this.statusCompany != 0){ //Loja Aberta.
          confirmOrder = true;
          if(this.company.companyHours.online == 0){
            activeOnline = false;
          }
        }
        else if(this.statusCompany == 0 && this.company.configs.closeScheduling == 1){ //Loja fechada + agendamento com loja fechada abilitado
          confirmOrder = true;
        }
        else if(this.statusCompany == 0 && this.company.configs.closeScheduling == 0){ // Loja fechada + agendamento com loja fechada desabilitado
          confirmOrder = false;
        }

        if(confirmOrder || this.typeParam.type == 1 || this.typeParam.type == 2)
        {
          if(!activeOnline){
            this.notify.error(`Loja Fechada!<br>Não é possivel fazer pedido, pois a loja encontra-se temporariamente fechada.`); 
            return;
          }

          if(this.permissionRequest){
            this.addProduct();
            this.goback();
          }
          else{
            this.notify.error('Pedido em conta!<br>Não é possivel fazer pedido, aguarde o garçom!');
          }
        }
        else{
          this.notify.error(`Loja Fechada!<br>Não é possivel fazer pedido, pois a loja encontra-se fechada`);
          this.goback()
        }

      }

    //#endregion

    //#region Filtro

      //Função responsavel por fazer o filtro de pesquisa
      updatefilter(event: Event) {
        this.filter = (event?.target as HTMLInputElement).value.toLowerCase();
        this.counterLengthSub();

      }

      //Calcula se as subcategorias tem produtos visiveis
      counterLengthSub(){
        this.subCategoryEmpty = []
        this.produto.categories.forEach(category => {

          const visibleElementsCount = category.products.reduce((count, adicional) => {
            return adicional.name.toLowerCase().includes(this.filter) || this.filter == '' ? count + 1 : count;
          }, 0);
          
          this.subCategoryEmpty.push(visibleElementsCount);
        });

        // console.log(this.subCategoryEmpty)
      }
      
    //#endregion

  //#endregion

}
